
// this code will load the config from process.env which is filled by webpack at build time

let env = {
    VUE_APP_ATTACHMENTS_MICRO_HOST_URL: process.env.VUE_APP_ATTACHMENTS_MICRO_HOST_URL,
    VUE_APP_ERP_API_HOST_URL: process.env.VUE_APP_ERP_API_HOST_URL,
};
//@ts-ignore
if (window.env) {
    for (const k in env) {
        //@ts-ignore
        if (window.env[k]) {
            //@ts-ignore
            env[k] = window.env[k];
        }
    }
}

export const config = env;

